import React, { useEffect, useRef } from 'react';
import Chart from 'chart.js';

const HeartRateChart = ({ data }) => {
  const chartRef = useRef(null);

  useEffect(() => {
    const ctx = chartRef.current.getContext('2d');
    const myChart = new Chart(ctx, {
      type: 'line',
      data: {
        labels: data.labels,
        datasets: [
          {
            label: 'Heart Rate',
            borderColor: '#12A150',
            data: data.datasets[0].data,
          },
        ],
      },
    });

    return () => {
      myChart.destroy(); // Cleanup on component unmount
    };
  }, [data]);

  return (
    <div>
    
      <canvas ref={chartRef} width="400" height="200"></canvas>
    </div>
  );
};

export default HeartRateChart;



// WEBPACK FOOTER //
// ./src/component/frontend/HeartRateChart.js